import React, { useEffect, useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import { getCroppedImgBlob, rotateImage90Degrees } from 'utils/files/images';

import styles from './styles.module.scss';

const ImageCropper = ({
  activeTaskName,
  crop,
  croppedImageUrl,
  croppingActive,
  previewImage,
  sourceImage,
  setCrop,
  setCroppedBlob,
  setCroppedImageUrl,
  setSourceImage,
  uploadedImageBlob
}) => {
  const [displaySrc, setDisplaySrc] = useState(null);

  useEffect(() => {
    let isActive = true;

    const prepareImage = async () => {
      if (previewImage && !uploadedImageBlob) {
        try {
          const rotated = await rotateImage90Degrees(previewImage);
          if (isActive) setDisplaySrc(rotated);
        } catch (error) {
          console.error('Failed to rotate image:', error);
          if (isActive) setDisplaySrc(previewImage);
        }
      } else if (uploadedImageBlob) {
        if (isActive) setDisplaySrc(uploadedImageBlob);
      } else {
        if (isActive) setDisplaySrc(null);
      }
    };
    prepareImage();

    return () => {
      isActive = false;
    };
  }, [previewImage, uploadedImageBlob]);

  const onImageLoaded = (img) => {
    setSourceImage(img);
  };

  const onCropComplete = (crop) => {
    makeClientCrop({ crop });
  };

  async function makeClientCrop({ crop }) {
    if (sourceImage && crop.width && crop.height) {
      const blob = await getCroppedImgBlob({ sourceImage, crop });
      setCroppedBlob(blob);
      const url = URL.createObjectURL(blob);
      setCroppedImageUrl(url);
    }
  }

  return (
    <div className={styles.cropContainer}>
      {displaySrc && croppingActive && (
        <ReactCrop
          src={displaySrc}
          crop={crop}
          keepSelection
          ruleOfThirds
          onImageLoaded={onImageLoaded}
          onChange={setCrop}
          onComplete={onCropComplete}
          draggable={false}
          className={styles.reactCropWrapper}
        />
      )}
      {(croppedImageUrl || displaySrc) && !croppingActive && (
        <img
          alt={`Cropped document of ${activeTaskName}`}
          className={styles.previewImage}
          src={croppedImageUrl || displaySrc}
        />
      )}
    </div>
  );
};

export default ImageCropper;
